export { default } from "./DelayedLoadingContainer";
export type { DelayedLoadingContainerProps } from "./DelayedLoadingContainer";
